import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class ClientePocForm extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      contacto: ['required'],
      telefono: ['required'],
      email: ['required', 'email']
    }
  }

  componentDidMount() {
    const { data } = this.props;

    if (!!data.rfc) {
      this.handleOnChange({});
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const { step } = this.props;
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step,
      isValid: validator.passes()
    });
  }

  render() {
    const { data, autoFocus } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Persona de contacto"
          name="contacto"
          placeholder=""
          help=""
          autoFocus={ autoFocus || false }
          validator={ validator }
          value={ data.contacto }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Teléfono"
          name="telefono"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.telefono }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Email"
          name="email"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.email }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default ClientePocForm;